import { useState } from "react";
import { Button, Switch, Popconfirm, DatePicker, Skeleton } from "antd";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { editShift } from "../../redux/actions/shift";
import CustomTable from "../../common/CustomTable";

const AllShifts = ({ allShifts, pagination, onPageChange, onPageSizeChange, loading }) => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentRecord, setCurrentRecord] = useState(null);

  const columns = [
    { title: "ID", dataIndex: "id" },
    { title: "Ambulance", dataIndex: ["ambulance", "ambulanceNumber"] },
    { title: "Shift Type", dataIndex: "shiftType" },
    {
      title: "From Date",
      dataIndex: "fromDate",
      render: (date) => (Array.isArray(date) && date.length > 0 ? date.join("/") : "-"),
    },
    {
      title: "To Date",
      dataIndex: "toDate",
      render: (date) => (Array.isArray(date) && date.length > 0 ? date.join("/") : "-"),
    },
    {
      title: "GeoFencing",
      dataIndex: "geoFencingEnabled",
      render: (value) => (value ? "Yes" : "No"),
    },
    { title: "Employee Name", dataIndex: ["employee", "employeeName"] },
    { title: "Employee Code", dataIndex: ["employee", "employeeCode"] },
    { title: "Mobile Number", dataIndex: ["employee", "mobileNumber"] },
    {
      title: "Action",
      render: (_, record) => (
        <>
          <Switch
            key={record.geoFencingEnabled ? "on" : "off"}
            style={{ margin: "0 8px" }}
            checked={record.geoFencingEnabled}
            checkedChildren="Geo ON"
            unCheckedChildren="Geo OFF"
            onChange={() => changeGeoFencing(record)}
          />
          <Popconfirm
            title={
              <>
                <h4>Are you sure you want to end this shift?</h4>
                <DatePicker
                  onChange={handleDateChange}
                  placeholder="Select End Date"
                  style={{ width: "100%" }}
                  value={selectedDate}
                  disabledDate={(current) => current && current.isBefore(dayjs().startOf("day"))}
                />
              </>
            }
            onConfirm={() => handleEndShift(record)}
            onCancel={() => setCurrentRecord(null)}
            okText="Yes"
            cancelText="No"
          >
            <Button onClick={() => setCurrentRecord(record)}>End Shift</Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  const changeGeoFencing = (record) => {
    const modifiedObject = {
      ambulanceId: record.ambulance.ambulanceId,
      shiftType: record.shiftType,
      geofencing: !record.geoFencingEnabled,
      employeeIds: [record.employee.employeeId],
      fromDate: Array.isArray(record.fromDate) ? record.fromDate.join("-") : "",
      toDate: Array.isArray(record.toDate) ? record.fromDate.join("-") : "",
    };
    dispatch(editShift(modifiedObject, record.id));
  };

  const handleEndShift = (record) => {
    if (!selectedDate) return;

    const endShiftData = {
      ambulanceId: record.ambulance.ambulanceId,
      shiftType: record.shiftType,
      geofencing: record.geoFencingEnabled,
      employeeIds: [record.employee.employeeId],
      fromDate: Array.isArray(record.fromDate) ? record.fromDate.join("-") : "",
      toDate: dayjs(selectedDate).format("YYYY-MM-DD"),
    };

    dispatch(editShift(endShiftData, record.id));
    setCurrentRecord(null);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>All Shifts</h2>
      {loading ? (
        <Skeleton active paragraph={{ rows: 10 }} />
      ) : (
        <CustomTable
          columns={columns}
          data={allShifts}
          loading={loading}
          pagination={pagination}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      )}
    </div>
  );
};

export default AllShifts;
